import twMerge from './twMerge'
import clsx from 'clsx'

/*
 * A clsx and twMerge wrapper
 */
export default function classes(...inputs: Parameters<typeof clsx>) {
  return twMerge(clsx(...inputs))
}
